import { API_ENDPOINT } from 'utils/constants';
import { submit } from 'utils/proxy';

const inquiryService = {
  getListEkyc,
  getDetailEkyc,
};

function getListEkyc(payload) {
  const { size, page, referenceNumber, dateCreated, identityNo, status, name } = payload;

  const params = {
    size: size ? size : 10,
    page: page ? page : 1,
  };

  if (referenceNumber) params.referenceNumber = referenceNumber;
  if (dateCreated) params.dateCreated = dateCreated;
  if (identityNo) params.identityNo = identityNo;
  if (name) params.name = name;
  if (status) params.status = status; // PENDING, FAILED, APPROVED, PASS

  return submit('GET', `${API_ENDPOINT}/api/v1/onboarding/inquiry`, params, {});
}

function getDetailEkyc(id) {
  return submit('GET', `${API_ENDPOINT}/api/v1/onboarding/inquiry/history/${id}`, {}, {});
}

export default inquiryService;